import { ReactNode } from "react";
import { Box } from "~/components/Box";
import { Text } from "~/components/Text";
import { H5 } from "~/components/Typography";

export interface SectionProps {
  title: string;
  description?: string;
  children: ReactNode;
}

export const Section = ({ title, description, children }: SectionProps) => (
  <Box css={{ mb: "$12" }}>
    <H5 css={{ fw: "700" }}>{title}</H5>
    {!!description && (
      <Box css={{ mt: "$2" }}>
        <Text variant="dark" size="3">
          {description}
        </Text>
      </Box>
    )}
    <Box css={{ mt: "$5" }}>{children}</Box>
  </Box>
);

Section.displayName = "Section";
